export default __webpack_public_path__ + "static/media/uz.a1a8b587.svg";